import React from "react";
import image from "./images/collaboration.jpg";
import Layout, { CAPABILITIES_LOOKUP, TAB_LOOKUP } from "./Layout";
import ArrowButton from "./ArrowButton";
import "./Capabilities9CollaborationScreen.scss";
import { t } from "i18next";

function Capabilities9CollaborationScreen() {
  return (
    <div className="fill-absolute">
      <div
        className="container row"
        style={{
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        <div
          className="full-height padding flex mobile-nav-padding"
          style={{
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
        >
          <h2 className="green-header">{t("Capability9.title")}</h2>
          <p>{t("Capability9.section1")}</p>
          <div className="horizontal-center">
            <img src={image} alt="video chat on a laptop" />
          </div>
          <div className="spacer" />
        </div>
        <div
          className="full-height padding flex full-center"
          style={{
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
        >
          <div className="forced-row">
            <div className="green-bullet"></div>
            <p>
              <span className="bold">{t("Capability9.section2-bullet1")}</span>{" "}
              {t("Capability9.section2-bullet1-desc")}
            </p>
          </div>
          <div className="forced-row">
            <div className="green-bullet"></div>
            <p>
              <span className="bold">{t("Capability9.section2-bullet2")}</span>{" "}
              {t("Capability9.section2-bullet2-desc")}
            </p>
          </div>

          <div className="forced-row">
            <div className="green-bullet"></div>
            <p>
              <span className="bold">{t("Capability9.section2-bullet3")}</span>{" "}
              {t("Capability9.section2-bullet3-desc")}
            </p>
          </div>

          <div className="forced-row">
            <div className="green-bullet"></div>
            <p>
              <span className="bold">{t("Capability9.section2-bullet4")}</span>{" "}
              {t("Capability9.section2-bullet4-desc")}
            </p>
          </div>

          <div className="forced-row">
            <div className="green-bullet"></div>
            <p>
              <span className="bold">{t("Capability9.section2-bullet5")}</span>{" "}
              {t("Capability9.section2-bullet5-desc")}
            </p>
          </div>
        </div>
      </div>
      <div className="buttons-container">
        <ArrowButton
          to="/capabilities-real-time-employee-guidance"
          side="left"
        ></ArrowButton>
        <ArrowButton
          to="/capabilities-insights-analytics"
          side="right"
        ></ArrowButton>
      </div>
    </div>
  );
}

export default Capabilities9CollaborationScreen;
